module.exports = __webpack_public_path__ + "static/media/texture.b0bd84b2.png";